import { z } from "zod";

export const basicInfoSchema = z.object({
  dob: z.string(),
  blood_group: z.string(),
});

export type BasicInfoValues = z.infer<typeof basicInfoSchema>;

export const bloodGroupSchema = z.object({
  blood_group: z.enum(
    ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],
    {
      required_error: "Select a blood group",
    },
  ),
});

export type BloodGroupFormValues = z.infer<typeof bloodGroupSchema>;